import { cn } from "@repo/utils";

export default function FormationRSE() {
  return (
    <>
      <div
        className={cn("mx-20 mb-20 self-center text-center text-3xl font-medium")}
      >
        Formation RSE : Maîtriser les fondamentaux de la norme ISO 26000 et sa
        mise en oeuvre - 2 jours
      </div>

      <div className={cn("text-xl")}>
        Structurer une démarche RSE et répondre aux questionnaires RSE de vos
        clients
      </div>
      <div className={cn("space-y-4 text-sm")}>
        <div>
          Vous souhaitez mieux structurer votre démarche en matière de
          Responsabilité Sociétale? Vous souhaitez optimiser vos réponses aux
          questionnaires RSE et fournir à vos commerciaux les bases nécessaires
          pour répondre de manière efficace à ce type de demande ?
        </div>
        <div>
          Notre formation vous donnera les clés pour vous permettre de traduire
          les principes de la Responsabilité Sociétale des Entreprises décrits
          dans la norme ISO 26000 en actions concrètes et de mieux répondre à
          vos clients.{" "}
        </div>
      </div>
      <div className={cn("font-semibold")}>Déroulé de la formation :</div>
      <div className={cn("text-sm")}>
        {`Après une introduction aux lignes directrices de l'ISO 26000, une
            journée et demie sera consacrée à un atelier axé sur une étude de
            cas. Cet aspect pratique vous aidera à appréhender les étapes
            capitales de définition d'une feuille de route pertinente, en
            identifiant :`}
      </div>
      <ul className={cn("list-disc space-y-4 pl-12 text-sm")}>
        <li>Vos enjeux et risques principaux</li>
        <li>Les attentes de vos clients et autres parties prenantes</li>
        <li>{`L'identification d'actions RSE vous apportant de la valeur ajoutée`}</li>
        <li>{`L'optimisation de vos réponses aux questionnaires RSE`}</li>
      </ul>
      <div className={cn("font-semibold")}>Lieux des sessions :</div>
      <div className={cn("text-sm")}>
        {`Toutes nos formations sont réalisées dans nos locaux à La Défense - Tour PBS 8ème étage Aile Ouest 1, avenue du
Général de Gaulle 92800 PUTEAUX.`}
      </div>
      <div className={cn("font-semibold")}>Coût de la formation :</div>
      <ul className={cn("list-disc space-y-4 pl-12 text-sm")}>
        <li>
          1400 euros HT: comprenant les rafraîchissements, les déjeuners et le
          matériel de formation
        </li>
      </ul>
      <div className={cn("text-sm")}>
        Pour tout renseignement complémentaire nous vous prions de contacter
        Sarah VIRTUOSE au +33 (0)142 54 01 21.
      </div>
      <div className={cn("self-end pt-24")}>
        <img
          src="/images_pj/logo_intertek.png"
          alt="logo_intertek"
          width={150}
          height={100}
        />
      </div>
    </>
  );
}

FormationRSE.title = `Formation RSE - description`;
